import React, { useState } from 'react'

const ContextoDonacion = React.createContext()

const ProveedorDonacion = ({ children }) => {
    const [donacion, cambiarDonacion] = useState(false)

    const cambiar = () => {
        cambiarDonacion(!donacion)
    }
    return (
        <ContextoDonacion.Provider value={{ donacion, cambiar }}>
            {children}
        </ContextoDonacion.Provider>
    );
}

export { ProveedorDonacion, ContextoDonacion };